import { render, staticRenderFns } from "./AddPdfTemplateDialog.vue?vue&type=template&id=5ce7bb0c"
import script from "./AddPdfTemplateDialog.vue?vue&type=script&lang=js"
export * from "./AddPdfTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports